import { api } from 'constants/api';
import { useMutation } from '@tanstack/react-query';

import { MutationOptions } from 'types/utils/mutation-options';
import { ApiResponse } from 'types/utils/api-response';
import { TestMessagePayload } from './useSendTestMessage';

type Response = unknown;

type Params = {
  name: string;
  store_ids: number[];
  scheduled_time: number | null;
  message: TestMessagePayload;
  channel: 'push' | 'sms' | null;
};

export const useCreateNewCampaign = (
  options: MutationOptions<Response, Params>
) =>
  useMutation({
    mutationFn: async (params: Params) => {
      const { data } = await api.post<ApiResponse<Response>>(
        `/campaign`,
        params
      );

      return data.data;
    },
    ...options,
  });
